<template>
    <section :class="namespace()">
        <mbg
            v-if="option.layout === 'mbg'"
            ref="table"
            :namespaced="namespaced"
            :skin="skin"
            :formatter="formatter"
            :hover="hover"
            :option="option"
            :groupKey="groupKey"
            :columns="columns"
            :rows="rows"
            :selectRowIds="selectRowIds"
            :focusRowId="focusRowId"
            :labels="labels"
            :sortColumn="sortColumn"
            :scrollTop="scrollTop"
            :scrollLeft="scrollLeft"
            :columnWidth="columnWidth"
            :hoverRow="hoverRow"
            :frozenGroupHeader="frozenGroupHeader"
            @rows-selected-changed="$emit('rows-selected-changed', $event)"
            @icon-click="onIconClick"
            @visible-rows-update="$emit('visible-rows-update', $event)"
            @cell-click="$emit('cell-click', $event)"
            @row-click="$emit('row-click', $event)"
            @row-double-click="$emit('row-double-click', $event)"
            @row-mouse-enter="$emit('row-mouse-enter', $event)"
            @row-mouse-leave="$emit('row-mouse-leave', $event)"
            @cell-mouse-enter="$emit('cell-mouse-enter', $event)"
            @cell-mouse-leave="$emit('cell-mouse-leave', $event)"
            @render-complete="$emit('render-complete', $event)"
            @scroll="onScroll"
            @sort="$emit('sort', $event)"
            @column-width-changed="$emit('column-width-changed', $event)"
        ></mbg>
        <markets-table
            v-else
            ref="table"
            :namespaced="namespaced"
            :skin="skin"
            :formatter="formatter"
            :hover="hover"
            :option="option"
            :groupKey="groupKey"
            :columns="columns"
            :rows="rows"
            :selectRowIds="selectRowIds"
            :focusRowId="focusRowId"
            :labels="labels"
            :sortColumn="sortColumn"
            @rows-selected-changed="$emit('rows-selected-changed', $event)"
            @icon-click="onIconClick"
            @visible-rows-update="$emit('visible-rows-update', $event)"
            @cell-click="$emit('cell-click', $event)"
            @row-click="$emit('row-click', $event)"
            @row-double-click="$emit('row-double-click', $event)"
            @row-mouse-enter="$emit('row-mouse-enter', $event)"
            @row-mouse-leave="$emit('row-mouse-leave', $event)"
            @cell-mouse-enter="$emit('cell-mouse-enter', $event)"
            @cell-mouse-leave="$emit('cell-mouse-leave', $event)"
            @render-complete="$emit('render-complete', $event)"
        ></markets-table>
        <markets-ui-popover
            v-if="computedHover.menu.length"
            :class="namespace('popover')"
            :namespaced="namespaced"
            :visible="popover.visible"
            :target="popover.target"
            :skin="skin"
            :width="computedHover.width"
            @hide="hideHoverMenu"
        >
            <header
                :class="[
                    mdsNS('popover__header'),
                    namespace('__header'),
                    skinStyle
                ]"
            >
                <div :class="namespace('__header-title')">
                    <h3 :class="mdsNS('popover__title')">
                        {{ computedHover.title }}
                    </h3>
                </div>
            </header>
            <div :class="mdsNS('popover__content')">
                <markets-ui-list
                    :namespaced="namespaced"
                    :skin="skin"
                    :data-model="computedHover.menu"
                    @change="clickHoverMenu"
                    @click="clickHoverMenu"
                >
                </markets-ui-list>
            </div>
        </markets-ui-popover>
    </section>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
import baseMixin from './base-mixin';
import marketsTable from './table';
import mbg from './mbg';
export default {
    name: 'markets-ui-grid',
    mixins: [mixins, baseMixin],
    components: {
        marketsTable,
        mbg
    },
    data() {
        return {
            popover: {
                visible: false,
                target: null
            }
        };
    },
    created() {
        this.namespace = utils.namespace('ui-grid', false);
    },
    methods: {
        onHoverIconClick({ element, row }) {
            this.hideHoverMenu();
            this.popover.data = row;
            this.popover.target = element;
            if (this.option.layout === 'mbg') {
                this.popover.target.style.display = 'block';
            } else {
                this.popover.target.style.visibility = 'visible';
            }
            this.popover.visible = true;
        },
        hideHoverMenu() {
            if (this.popover.target) {
                if (this.option.layout === 'mbg') {
                    this.popover.target.style.display = '';
                } else {
                    this.popover.target.style.visibility = '';
                }
                this.popover.visible = false;
            }
        },
        clickHoverMenu(item) {
            this.hideHoverMenu();
            if (item.id === 'removable') {
                this.$refs.table.removeRows(this.popover.data);
            } else if (item.id === 'view') {
                return;
            } else {
                this.$emit('hover-menu-click', {
                    item,
                    row: this.popover.data
                });
            }
        },
        onIconClick({ element, row }) {
            const classList = element.classList;
            if (
                classList.contains(
                    this.$refs.table.namespace('__button--icon-only-hover')
                )
            ) {
                this.onHoverIconClick({ element, row });
            }
            this.$emit('icon-click', { element, row });
        },
        onScroll() {
            this.$emit('scroll', ...arguments);
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-grid';
.#{$namespace} {
    height: 100%;
    overflow: auto;
}
</style>
